module.exports = __webpack_public_path__ + "img/顺带哥-太阳码.971e8162.jpg";